module.exports = new __parcel__URL__("vscode.b2ce41b7.svg").toString();